import React, { Component } from 'react';
import Routes from './routes/Routes';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'react-tagsinput/react-tagsinput.css';
import './assets/scss/theme.scss';

/**
 * Main app component
 */
class App extends Component {

  render() {
    
    return ( 
            <>
            <ToastContainer 
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
              <Routes/>
            </>
          
          );
  }
}

export default App;
